import {
  Component,
  HostListener,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { finalize, Subscription } from 'rxjs';
import { MegacableAuthService } from 'src/app/core/services/megacable-auth.service';

export interface HeaderUsuario {
  nombre: string;
}

@Component({
  selector: 'app-header-one',
  templateUrl: './header-one.component.html',
  styleUrls: ['./header-one.component.scss']
})
export class HeaderOneComponent {

  @Input() themeLogo = 'assets/images/mega-white.png';
  @Input() topbar = false;
  @Input() sticky = false;

  stick = false;
  usuario: HeaderUsuario | null = null;
  btnIniciar = 'Iniciar';
  private logoutInProgress = false;
  private _authSub?: Subscription;
  private _logoutSub?: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly router: Router,
    private readonly megacableAuth: MegacableAuthService
  ) { }

  ngOnInit(): void {
    this._syncHeaderFromAuth();
    this.megacableAuth.restoreSession();

    this._authSub = this.megacableAuth.sessionChange$.subscribe(() => {
      this._syncHeaderFromAuth();
    });
  }

  ngOnDestroy(): void {
    this._authSub?.unsubscribe();
    this._logoutSub?.unsubscribe();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.stick = window.pageYOffset >= 150 && window.innerWidth > 400;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.onWindowScroll();
  }

  setUsuario(usuario: HeaderUsuario | null): void {
    this.usuario = usuario;
    this.btnIniciar = usuario?.nombre ? `Hola, ${usuario.nombre}` : 'Iniciar';
  }

  logout(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.logoutInProgress) {
      return;
    }

    this.logoutInProgress = true;
    this._logoutSub = this.megacableAuth
      .logout()
      .pipe(finalize(() => {
        this.logoutInProgress = false;
      }))
      .subscribe({
        next: () => {
          this.router.navigateByUrl('/');
        }
      });
  }

  private _syncHeaderFromAuth(): void {
    const profile = this.megacableAuth.getProfile();
    if (this.megacableAuth.isAuthenticated() && profile?.firstName?.trim()) {
      this.setUsuario({ nombre: profile.firstName.trim() });
      return;
    }
    this.setUsuario(null);
  }
}
